// open popup on wrapper click
$(document).on("click", ".product__gallery .gallery__image-wrapper", function () {
  $('body').addClass("overflow-hidden");
  const $clickedWrapper = $(this);
  const index = $clickedWrapper.index(); // clicked wrapper index (0-based)

  // remove any existing overlay
  $(".zoom-wrapper").remove();

  // declare outside so it's available after if/else
  let $galleryClone;

  if ($(window).width() > 991) {
    $galleryClone = $(".product__gallery .product-slide").clone(true, true);
  } else {
    $galleryClone = $(".product__gallery .flickity-slider").clone(true, true);
  }

  // guard
  if (!$galleryClone || !$galleryClone.length) {
    console.warn("No gallery found to clone");
    return;
  }

  // create overlay and close button
  const $zoomWrapper = $('<div class="zoom-wrapper"></div>');
  const $closeBtn = $('<div class="close-btn"></div>');
  $zoomWrapper.append($closeBtn).append($galleryClone);
  $("body").append($zoomWrapper);

  // find cloned wrappers and target
  const $clonedWrappers = $zoomWrapper.find(".gallery__image-wrapper");
  const $targetWrapper = $clonedWrappers.eq(index - 1);

  // ✅ use position() relative to zoom-wrapper
  const offsetTop = $targetWrapper.position().top;

  // scroll to same image in overlay
  $zoomWrapper.scrollTop(offsetTop);
});


// close overlay by clicking image OR video inside zoom
$(document).on("click", ".zoom-wrapper .close-btn, .zoom-wrapper img, .zoom-wrapper video", function () {
  $('body').removeClass("overflow-hidden");
  $(".zoom-wrapper").remove();
});
